import type { ReactNode, JSX } from 'react'

import { ArrowUpRightIcon } from '@buffer-mono/popcorn'
import { format } from 'date-fns'

import type { Image } from '~publish/legacy/composer/composer/entities/factories'
import { SERVICE_STARTPAGE } from '~publish/legacy/constants'

import {
  getPreviewCharLimit,
  textExceedsCharLimit,
  truncateText,
  getMediaProperties,
  gifAsImage,
} from '../../../Common/utils'
import type { StartPageContent } from '../../../types'

import styles from './Post.module.css'

const maxLength = getPreviewCharLimit(SERVICE_STARTPAGE)
const getTextToDisplay = (text?: string): string | undefined => {
  let textToDisplay = text
  textToDisplay = truncateText(textToDisplay, maxLength, true)

  return textToDisplay
}

const ImagePreview = ({ images }: { images: Image[] }): JSX.Element => {
  const firstImage = images[0]
  return (
    <div
      className={styles.image}
      data-testid="preview-images"
      style={{ backgroundImage: `url(${firstImage.url})` }}
    />
  )
}

const FeatureFlagWrapper = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  return <>{children}</>
}

const StartPagePost = ({
  content,
}: {
  content: StartPageContent
}): JSX.Element => {
  const { text, images, gif, channelData } = content
  const currentDate = format(new Date(), 'LLL dd')
  const link = channelData?.startPage?.link
  const allImages = images?.length ? images : gif ? [gifAsImage(gif)] : []
  const { hasImages, hasGif } = getMediaProperties(content, null)

  return (
    <FeatureFlagWrapper>
      <div className={styles.content}>
        <div className={styles.textWrapper}>
          <div className={styles.date}>{currentDate}</div>
          {text && (
            <div className={styles.text}>
              <span translate="no">{getTextToDisplay(text)}</span>
              {textExceedsCharLimit(text, maxLength) && (
                <div className={styles.seeMore}> Read more</div>
              )}
            </div>
          )}
        </div>
        {(hasImages || hasGif) && <ImagePreview images={allImages} />}
      </div>
      {link && (
        <a
          className={styles.link}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Find out more <ArrowUpRightIcon size="xsmall" />
        </a>
      )}
    </FeatureFlagWrapper>
  )
}

export default StartPagePost
